export const maxLatitude = 90;
export const minLatitude = -90;
export const maxLongitude = 180;
export const minLongitude = -180;
export const maxPurchasePrice = 99999999.99;
export const UPLOAD_EXPIRATION_HOURS = 3;

/**
 * Where the Akili User Guide lives: the project site's copy, which is one site
 * for every environment. The file name carries no edition, so a new edition
 * replaces the file in place and this address never changes (AKL-1117).
 */
export const USER_GUIDE_URL =
  "https://projectakili.ai/Portals/11/Akili_User_Guide.pdf";
